import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private jwtHelper: JwtHelperService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // URLs qui ne nécessitent aucune modification
    const excludedUrls = ['token/', 'refresh/', 'verify/', 'blacklist/'];
    if (excludedUrls.some(url => request.url.includes(url))) {
      return next.handle(request);
    }

    // Cloner la requête avec les credentials
    let modifiedRequest = request.clone({
      withCredentials: true
    });

    // Ajouter les headers (JWT + API Key)
    modifiedRequest = this.addHeaders(modifiedRequest);

    return next.handle(modifiedRequest);
  }

  // auth.interceptor.ts
  private addHeaders(request: HttpRequest<unknown>): HttpRequest<unknown> {
    const token = this.jwtHelper.tokenGetter();
    const headers: Record<string, string> = {
      'BSTP-API-KEY': environment.apiKey,  // Doit apparaître dans REQUEST Headers
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `JWT ${token}`;
    }

    // Clone et ajoute les headers à la REQUÊTE
    return request.clone({ setHeaders: headers });
  }
}